var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tabs-items',_vm._b({attrs:{"value":_vm.value},on:{"input":_vm.update}},'v-tabs-items',_vm.$props,false),[_vm._t("tabs-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }